// Function to display Delivery details popup similar to checkout viewcart page's popup
(function ($) {
  $('#order_arrival_info').click(function () {
    $.colorbox({
      html: $('#order_arrival_details_overlay').html(),
      className: 'colorbox_edd_know_more',
      fixed: 'true',
      maxWidth: '600px',
      maxHeight: '400px'
    });

    return false;
  });
})(jQuery);
